import { create } from 'zustand';
import _ from 'lodash';

interface initDataState {
  param: any;
  bindParam: any;
  result: any;
  initPayload: any;
  payload: any;
  bind: (result: { data: any }) => void;
  bindPayload: (payload: { data: any }) => void;
}

export const initLoanPayload = {
  name: '', //사용자명
  acct_year: '', //연말정산   년도
  co_cd: '', //회사코드
  co_id: '', //사번
  in_data_seqid: 0, //입력데이터 sequence
  rep_term: '', // "상환기간 1:10년이상 15년미만, 2: 15년이상 30년미만, 3:30년 이상"
  rep_date: '', // 차입일
  rep_method: '', //"상환방식 1:고정금리 또는 비거치식분할상환, 2:고정금리 이면서 비거치식분할상환, 3:기타 대출"
  bank_cd: '', //금융사코드
  account_num: '', //계좌번호
  htx_amt: 0, //금액(국세청)
  amt: 0, //금액(기타)
  question_status: '', //설문상태
};

/**
  장기주택저당차입금
**/
export const loanDataStore = create<initDataState>(set => ({
  param: { initialSeq: 0 },
  bindParam: (bind: any) =>
    set(state => ({
      ...state,
      param: { ...state.param, ...bind },
    })),
  result: [],
  bind: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, ...data },
    })),
  initPayload: initLoanPayload,
  payload: _.cloneDeep(initLoanPayload),
  bindPayload: (data: any) =>
    set(state => ({
      ...state,
      payload: { ...state.payload, ...data },
    })),
}));
